import React from 'react';
import { DeleteOutline as DeleteIcon } from '@mui/icons-material';
import { IconButton } from '@mui/material';
import { DeleteRowButtonProps } from './DeleteRowButton.props';
import { classes, StyledTooltip } from './DeleteRowButton.styles';



const DeleteRowButton = ({ rowIndex, deleteRow }: DeleteRowButtonProps) => (
  <StyledTooltip
    PopperProps={{
      disablePortal: true,
    }}
    title="Delete row"
    placement="top"
    className="delete-button"
    arrow>
    <IconButton
      onClick={() => {
        deleteRow(rowIndex);
      }}
      className={classes.deleteButton}>
      <DeleteIcon fontSize="small" />
    </IconButton>
  </StyledTooltip>
);

export default DeleteRowButton;
